import axios from 'axios';
import { getCookie } from '../utils/cookie';
export var setAxiosDefaultHeaders = function () {
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    setAxiosAuthorizationHeader();
};
export var getUserToken = function () {
    return getCookie('user_token');
};
var setAxiosAuthorizationHeader = function () {
    var userToken = getUserToken();
    if (userToken) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + userToken;
        return;
    }
    delete axios.defaults.headers.common['Authorization'];
};
